<template>
    <div id="NotFound">
        <h1>404</h1>
        <h2>Page Not Found</h2>
    </div>
</template>

<script>
    export default {
        name: "NotFound",
        data() {
            return {}
        },
        methods: {}
    }
</script>

<style scoped>

</style>